module.exports = __webpack_public_path__ + "static/Elle-362bdf785393d58029634400d16a1e5d.svg";